import { Component, OnInit } from "@angular/core";
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";
import { DataService_ScheduledJobs } from "../../shared/data.service";
import { RecipientRequest } from "../../shared/Recipient-request";
import { ConfirmationService } from "primeng/api";

@Component({
	selector: "app-ri-add-recipients",
	templateUrl: "./ri-add-recipients.component.html",
	styleUrls: ["./ri-add-recipients.component.css"],
})
export class RiAddRecipientsComponent implements OnInit {
	constructor(
		private ref: DynamicDialogRef,
		private dialogConfig: DynamicDialogConfig,
		private dataService: DataService_ScheduledJobs,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		this.JobID = this.dialogConfig.data.JobID;

		this.loadUsers();
	}

	/////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////

	JobID: number = -1;

	pagerows: any = 10;
	pagefirst: any = 0;
	lstUsers: any = [];
	SelectedUsers: any = [];
	cols: any = [
		{ field: "Username", header: "Username" },
		{ field: "FirstName", header: "First Name" },
		{ field: "LastName", header: "Last Name" },
		{ field: "StaffID", header: "Staff ID" },
		{ field: "StaffTitle", header: "Title" },
		{ field: "SchoolFullName", header: "Home School" },
	];

	TableLoading: boolean = false;
	Processing: boolean = false;
	errorMessage: string = "";

	/////////////////////////////////////////////////////

	loadUsers() {
		this.TableLoading = true;

		var result = this.dataService.JobAddUsersSelectList();
		result.subscribe(
			(response) => {
				this.lstUsers = response;

				this.TableLoading = false;
			},
			(error) => {
				this.TableLoading = false;
			}
		);
	}

	/////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////

	onAdd() {
		this.Processing = true;

		var lstUID = this.SelectedUsers.map((user) => user.UserID);

		var parms: RecipientRequest = {
			JobID: this.JobID,
			lstRecipient: lstUID,
		};

		var result = this.dataService.JobRecipientInsert(parms);
		result.subscribe(
			(response: any) => {
				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "addrecipient",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Users were added to the from the report successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "addrecipient",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not add users to the report: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	/////////////////////////////////////////////////////

	/////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////

	IsLoading() {
		return this.TableLoading == true || this.Processing == true;
	}

	/////////////////////////////////////////////////////
}
